<div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center;">
    <mat-spinner color="primary"></mat-spinner>
</div>
